import React, { useState, useContext } from 'react'
import NPOSAccountHeader from './NPOSAccountHeader'
import NPOSAccountInner from './NPOSAccountInner'
import { appContext } from '../../../../App'
export const nposAccountControllerContext = React.createContext()

function useNPOSAccountController(props) {
  const app = useContext(appContext)
  const [activeTab, setActiveTab] = useState('users-accounts')
  const obj = {
    app,
    activeTab: [activeTab, setActiveTab]
  }
  return(obj)
}

function NPOSAccountController(props) {
  const nposAccountController = useNPOSAccountController(props)
  return (
    <React.Fragment>
      <nposAccountControllerContext.Provider value={nposAccountController}>
        <NPOSAccountHeader />
        <NPOSAccountInner />
      </nposAccountControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(NPOSAccountController)